import {
    ADD_CLICKTOPAY_FAILED, ADD_CLICKTOPAY_LOADING, ADD_CLICKTOPAY_REMOVE, ADD_CLICKTOPAY_SUCCESS
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
    ClickToPay: null,
    request: null,
};

export const ClickToPayReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any, request: any }
) => {
    switch (action.type) {
        case ADD_CLICKTOPAY_LOADING:
            return {
                ...state,
                loading: true,
            };
        case ADD_CLICKTOPAY_SUCCESS:
            return {
                ...state,
                loading: false,
                ClickToPay: action.payload,
                status: action.status,
                error: null,
                request: action.request
            };
        case ADD_CLICKTOPAY_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
                request: action.request

            };
        case ADD_CLICKTOPAY_REMOVE:
            return initialState

        default:
            return state;
    }
};




